import React from 'react';
import {Input} from "@material-tailwind/react";
import {reemplaceValue} from "../../utils/textOptions";
import {CustomTypography} from "./CustomTypography";
import {inputType} from "../../services/types/types";
import {useTranslation} from "react-i18next";

interface CustomInputProps {
    label?: string;
    labelFixel?: boolean;
    placeholder?: string;
    type?: inputType;
    value?: string;
    error?: string;
    className?: string;
    classNameContent?: string;
    textSize?: string;
    disabled?: boolean;
    mandatory?: boolean;
    maxLength?: number;
    onChangeText?: (text: string) => void;
    testId?: string;
}

const CustomInput = ({
                         label,
                         labelFixel,
                         placeholder,
                         disabled,
                         mandatory,
                         type,
                         error,
                         className,
                         classNameContent,
                         textSize,
                         maxLength,
                         testId,
                         ...props
                     }: CustomInputProps) => {
    const {t} = useTranslation("global") as { t: (key: string) => string }

    const handleInputChange = (event: any) => {
        return reemplaceValue(type, event.target.value, maxLength);
    };

    const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
        const {key} = event;
        const upperCaseKey = key.toUpperCase();

        if (
            (upperCaseKey < '0' || upperCaseKey > '9') && // Números
            upperCaseKey !== 'BACKSPACE' && // Backspace
            upperCaseKey !== 'DELETE' && // Delete
            upperCaseKey !== '-'
        ) {
            event.preventDefault();
        }
    };

    return (
        <div className={`${classNameContent} custom-input w-full grid grid-cols-1`}>
            {(props?.value !== '' || labelFixel) &&
                <div className={'label labelCustom'}>
                    <span
                        className={
                            `${disabled ? 'text-colorDisabled' : 'text-labelColor'} labelCustom normal-case text-[10px] ${label ? 'bg-white' : ''} ml-[18px] px-1 rounded-[5px] ${mandatory ? 'mt-[-2px]' : ''}`
                        }
                    >
                        {t(label ?? '')}{mandatory && <span className={'text-danger ml-[2px]'}>*</span>}
                    </span>
                </div>
            }
            <div className={`${(props?.value !== '' || labelFixel) ? 'input' : 'relative'}`}>
                <Input
                    data-testid={testId}
                    crossOrigin=''
                    type={type === 'integer' ? 'number' : type === 'password' ? 'password' : ''}
                    placeholder={placeholder}
                    value={props.value}
                    error={error !== undefined}
                    onKeyDown={type === 'integer' ? handleKeyDown : undefined}
                    disabled={disabled}
                    className={`${className ? className : ''} styleInput 
                ${error ? '!border-danger placeholder:text-danger' : disabled ? '!border-colorDisabled' : '!border-inputBorder'} 
                ${disabled ? 'cursor-text' : ''} 
                rounded-[4px] text-input pt-3 min-h-[40px] max-h-[40px] !border bg-white text-gray-900 shadow-lg 
                shadow-gray-900/5 ring-1 ring-transparent placeholder:text-gray-500 focus:!border-primary 
                focus:!border-t-primary focus:ring-white disabled:bg-white`}
                    containerProps={{className: "min-w-[52px]"}}
                    labelProps={{
                        className: "hidden",
                    }}
                    onChange={(e) => {
                        if (props.onChangeText) props.onChangeText(handleInputChange(e))
                    }}
                    style={{fontSize: `${textSize ? textSize : '$sizeText'}`}}
                />
                {error && <CustomTypography variant="small" style={{color: 'red'}}
                                            className="static font-normal ml-1 text-[10px]" text={error}/>}
            </div>
        </div>
    );
};

export default CustomInput;
